



import { Modal } from "reactstrap";
import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import React, { useState, useEffect } from "react";
const IntakeSum =({
    isOpen,
    onClose,
    container,
  }: {
    isOpen: boolean;
    onClose: () => void;
     style?: React.CSSProperties;
         container?: HTMLElement | null;
  }) =>{




    
     const [PumpData, setpumpdata] = useState<any[]>([]);  
const getAllPumpingStations = async () => {
  try {
    const response = await ApiService.axiosApi(`/tags`, {
      method: 'GET'
    });

    if (response.success) {
       
      
      setpumpdata(response.data); 
  
    } else {
       console.log('Failed to fetch pumping stations');
    }

  } catch (error) {
    console.error('Error fetching pumping stations:', error);
    console.log('Error fetching pumping stations');
  }
};

useEffect(() => {
    getAllPumpingStations();

     const intakeInterval =setInterval(()=>(
       getAllPumpingStations()
     ),5000)

     return () => clearInterval(intakeInterval);
  }, []);

    
     
     
    return(
         <>
          <Modal isOpen={isOpen} size='md' centered toggle={onClose}
      style={{
        zIndex: 9999, // High z-index
      }}
       container={container || document.body} // Use container prop or fallback to body
        
      modalClassName="custom-modal-class"
        backdropClassName="custom-backdrop-class"
        contentClassName="custom-content-class">
             <div className="sump-box-take">
  <div className="header-take">
    <span>INTAKE SUMP</span>
    <div className="icons-take">
      <button className="refreshButtonInTakeSump"onClick={getAllPumpingStations} style={{ cursor: 'pointer' }}>&#x21bb;</button>
      <button className="closeInTakesump" onClick={onClose}>&times;</button>
    </div>
  </div>

  <table className="sump-table-take">
    <tr>
      <td>LEVEL VALUE</td>
      <td className="value-take">{PumpData.find(tag => tag.name === "SUMP_LVL_VAL")?.value ?? 'Empty'}m</td>
    </tr>
    <tr>
      <td>HIGH HIGH SET POINT</td>
      <td className="value-take">{PumpData.find(tag => tag.name === "SUMP_LVL_HHSP")?.value ?? 'Empty'}m</td>
     
    </tr>
    <tr>
      <td>HIGH SET POINT</td>
      <td className="value-take">{PumpData.find(tag => tag.name === "SUMP_LVL_HSP")?.value ?? 'Empty'}m</td>
     
    </tr>
    <tr>
      <td>LOW SET POINT</td>
      <td className="value-take">{PumpData.find(tag => tag.name === "SUMP_LVL_LSP")?.value ?? 'Empty'}m</td>
      
    </tr>
  </table>
</div>
</Modal>
         </>
    )
}

export default IntakeSum;